// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1EFQf","tab":"Tabs_tab__2KkrH","tabActive":"Tabs_tabActive__2CFDA"};